import React from "react";
import styled from "styled-components";
import Checkbox from "@8x8/oxygen-checkbox";

export const StyledCheckbox = styled(Checkbox)`
  label {
    margin-bottom: 0;
  }
`;
